import styled from 'styled-components';

export const StyledBottombar = styled.div`
  height: 70px;
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  z-index: 999999;

  // Sidebar will disappear at 970px
  @media screen and (min-width: 1120px) {
    display: none;
  }
`;
export const StyledBottombarWrapper = styled.div`
  height: 70px;
  position: fixed;
  bottom: 0;
  align-items: center;
  text-align: center;
  z-index: 99999;
  width: 100%;

  // Sidebar will disappear at 970px
  @media screen and (min-width: 800px) {
    display: none;
  }
`;